import { tgxApi } from "../../../app/tgxApi";
import { getFileName, serialize } from "../../../helpers/utils/Utils";
import {
    getAuthorizationHeader, getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import { downloadFile } from "../../../helpers/utils/FileUtils";

export const metroAreasApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchMetroAreas: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/metro-areas?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['metroAreas'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createMetroArea: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/create/msa`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['metroAreas'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Metro Area")
            },
        }),

        getMetroAreaById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-metro-area-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['metroAreaById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getMetroAreaByStateAbbr: build.query({
            query: (stateAbbreviation) => {
                return {
                    url: `/ajax/get-metro-area-by-state-abbr/${stateAbbreviation}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getMetroAreaByStateId: build.query({
            query: (stateId) => {
                return {
                    url: `/ajax/get-metro-area-by-state-id/${stateId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getMetroAreaByStateIds: build.query({
            query: (stateIds) => {
                let list = { stateIds: stateIds }
                let paramData = serialize(list)
                return {
                    url: `/ajax/get-metro-area-by-state-ids?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateMetroArea: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/ajax/update/msa/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['metroAreas', 'metroAreaById', 'userAuditableInfo'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Metro Area")
            },
        }),

        deleteMetroArea: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-metro-area-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            invalidatesTags: ['metroAreas'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Metro Area")
            },
        }),
        exportMetroAreaData: build.query({
            query: (query) => {
                return {
                    url: `/export/metroArea`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("metroAreas"))
                        return { success: true };
                    },
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

    })
});

export const {
    useSearchMetroAreasQuery,
    useCreateMetroAreaMutation,
    useUpdateMetroAreaMutation,
    useGetMetroAreaByStateIdQuery,
    useGetMetroAreaByIdQuery,
    useLazyExportMetroAreaDataQuery,
    useLazyGetMetroAreaByStateAbbrQuery,
    useGetMetroAreaByStateAbbrQuery,
    useDeleteMetroAreaMutation,
    useGetMetroAreaByStateIdsQuery
} = metroAreasApi;